import { render } from "./LabelMetaStrip.vue?vue&type=template&id=4a5c1f60&scoped=true"
import script from "./LabelMetaStrip.vue?vue&type=script&lang=js"
export * from "./LabelMetaStrip.vue?vue&type=script&lang=js"

import "./LabelMetaStrip.vue?vue&type=style&index=0&id=4a5c1f60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5c1f60"]])

export default __exports__